
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';

@Component({})
export default class AppButton extends Vue {
	@Emit()
	private click(): void {}
}
